import styled from '@app/styled';
import { color, radius, spacing, typography } from '@app/theme';

export const KeepPlanHeadline = styled.p`
    ${typography('body')}
    padding-bottom: ${spacing(4)};
    margin-bottom: ${spacing(2)};
    border-bottom: 1px solid ${color('border.secondary')};
`;

export const KeepPlanBenefitsHeadline = styled.div`
    ${typography('caption2')}
    color: ${color('content.secondary')};
    margin-bottom: ${spacing(3)};
`;

export const BenefitsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-content: middle;
    gap: ${spacing(3)};
    margin-bottom: ${spacing(7)};
`;

export const BenefitItem = styled.div`
    display: flex;
    ${typography('caption1')}
`;

export const QuoteBlock = styled.div`
    display: grid;
    grid-template-columns: 1fr 148px;
    gap: ${spacing(2)};
    margin-top: ${spacing(7)};
`;

export const Quote = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    background-color: ${color('surface.secondary')};
    border-radius: ${radius('lg')};
    padding: ${spacing(2)};
`;

export const QuoteText = styled.div`
    ${typography('description')}
`;

export const QuoteAuthor = styled.div`
    ${typography('message')};
    color: ${color('content.secondary')};
`;
